const state = {
  show: {
    verifyForm: false,
    verifySuccess: false
  }
}

const mutations = {
  setShowVerifyForm (state, status) {
    state.show.verifyForm = status
  },
  setShowVerifySuccess (state, status) {
    state.show.verifySuccess = status
  },
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/verifyEmail.js